module.exports = __webpack_public_path__ + "img/profile__icon3.1b88452e.png";